export const SET_WALKTHROUGH_STEP = 'SET_WALKTHROUGH_STEP';
export const START_WALKTHROUGH = 'START_WALKTHROUGH';
export const STOP_WALKTHROUGH = 'STOP_WALKTHROUGH';
